import { handleActions } from 'redux-actions';
import { DeviceIndex, UtcTime, DeviceId } from 'types';
import {
    InitializationSuccessAction,
    InitializationFailureAction,
    SetCameraAndTimeAction,
    SetRequestedViewAction,
} from 'actions/appActions';

export type State = Readonly<{
    loading: boolean;
    initError: Error | null;
    cameraAndTime: Readonly<{
        deviceId?: DeviceId;
        deviceIndex?: DeviceIndex;
        utcTime?: UtcTime;
    }>;
    view: ReadonlyArray<DeviceIndex> | null;
}>;

export const initialState = Object.freeze<State>({
    loading: true,
    initError: null,
    cameraAndTime: Object.freeze({}),
    view: null,
});

export type ReducerAction =
    InitializationSuccessAction
    | InitializationFailureAction
    | SetCameraAndTimeAction
;

export type Reducer = (state: State, action: ReducerAction) => State;

export const appReducer: Reducer = handleActions({
    INIT_SUCCESS(state: State, action: InitializationSuccessAction) {
        return {
            ...state,
            loading: false,
            initError: null,
        };
    },

    INIT_FAILURE(state: State, action: InitializationFailureAction) {
        return {
            ...state,
            loading: false,
            initError: action.payload,
        };
    },

    SET_CAMERA_AND_TIME(state: State, action: SetCameraAndTimeAction) {
        return {
            ...state,
            cameraAndTime: action.payload,
        };
    },

    SET_REQUESTED_VIEW(state: State, action: SetRequestedViewAction) {
        return {
            ...state,
            view: action.payload,
        };
    },

// tslint:disable-next-line:no-any
} as any, initialState) as any;



// WEBPACK FOOTER //
// ./src/reducers/appReducer.ts